import apiClient from './client';

export interface ReviewDto {
  id: number;
  reviewerUserId: string;
  reviewerDisplayName: string;
  jobId?: number;
  qualityRating: number;
  reliabilityRating: number;
  communicationRating: number;
  pricingRating: number;
  comment: string;
  timestamp: string;
}

export interface JobReviewDto {
  id: number;
  jobId: number;
  contractorProfileId: number;
  qualityRating: number;
  reliabilityRating: number;
  communicationRating: number;
  pricingRating: number;
  comment: string;
  timestamp: string;
}

export interface MyReviewDto {
  id: number;
  jobId: number;
  jobTitle: string;
  contractorProfileId: number;
  contractorName: string;
  qualityRating: number;
  reliabilityRating: number;
  communicationRating: number;
  pricingRating: number;
  comment: string;
  timestamp: string;
}

export interface SubmitReviewData {
  contractorProfileId: number;
  jobId: number;
  qualityRating: number;
  reliabilityRating: number;
  communicationRating: number;
  pricingRating: number;
  comment: string;
}

export async function getReviewsForContractor(contractorProfileId: number): Promise<ReviewDto[]> {
  const response = await apiClient.get<ReviewDto[]>(`/Review/contractor/${contractorProfileId}`);
  return response.data;
}

export async function getReviewForJob(jobId: number): Promise<JobReviewDto | null> {
  const response = await apiClient.get<JobReviewDto | null>(`/Review/job/${jobId}`);
  return response.data;
}

export async function getUserReviewForContractor(contractorProfileId: number): Promise<ReviewDto | null> {
  const response = await apiClient.get<ReviewDto | null>(`/Review/contractor/${contractorProfileId}/my-review`);
  return response.data;
}

export async function submitReview(data: SubmitReviewData): Promise<void> {
  await apiClient.post('/Review', data);
}

export async function getMyReviews(): Promise<MyReviewDto[]> {
  const response = await apiClient.get<MyReviewDto[]>('/Review/my-reviews');
  return response.data;
}

export async function deleteReview(reviewId: number): Promise<void> {
  await apiClient.delete(`/Review/${reviewId}`);
}

export async function updateReview(
  reviewId: number,
  data: Omit<SubmitReviewData, 'contractorProfileId' | 'jobId'>,
): Promise<void> {
  await apiClient.put(`/Review/${reviewId}`, data);
}
